export default __webpack_public_path__ + "static/desktop-bg-top-leaves-d07135a3408135f2d2910341b58c298d.png";